import { Location, RawLocation, Route } from 'vue-router';
import { Nullable } from 'frontend/types';
import { PossibleAnswerSlug, PossibleCategoryId } from 'frontend/types/segmentation';

export const returningUserNuxSteps: { [key: string]: number } = {
  nux_welcome_product_reason_two: 2,
  nux_welcome_testimonial: 3,
  total: 3,
};

// New steps count for bcu style slides
export const nuxStepsData: { [key: string]: number } = {
  nux_welcome: 1,
  nux_welcome_product_reason_one: 2,
  nux_welcome_math_comfort: 3,
  nux_welcome_academic: 4,
  nux_welcome_career: 4,
  nux_welcome_try: 4,
  nux_welcome_product_reason_two: 5,
  nux_welcome_testimonial: 6,
  total: 6,
};

export function withPreservedQueryParams(
  route: Route,
  location: Location,
  params: string[],
): RawLocation {
  const queryParams: { [key: string]: string | Array<Nullable<string>> } = {};
  params.forEach(q => {
    const param = route.query[q];
    if (param) {
      queryParams[q] = route.query[q];
    }
  });

  return {
    ...location,
    query: {
      ...location.query,
      ...queryParams,
    },
  };
}

export const answerSlugForCategoryId: { [key: number]: PossibleAnswerSlug } = {
  1: 'student',
  2: 'professional',
  3: 'hobbyist',
  4: 'teacher',
  5: 'goal-other',
  6: 'parent',
};

export const categoryIdForAnswerSlug: { [key: string]: PossibleCategoryId } = {
  student: 1,
  professional: 2,
  hobbyist: 3,
  teacher: 4,
  'goal-other': 5,
  parent: 6,
};
